import React from 'react';
import './redirects.css';

const redirectEntries = [
  {
    domain: 'brogverse.cc',
    destination: 'https://brogverse.cc/',
    notes: 'Main landing page'
  },
  {
    domain: 'status.brogverse.cc',
    destination: 'https://brogverse.cc/status',
    notes: 'Minecraft and service status'
  }
];

const RedirectsPage = () => {
  return (
    <div className="redirects-page">
      <h1>Domain Redirects</h1>
      <p className="redirects-intro">A quick list of your domain redirects and destinations.</p>
      <div className="redirects-table-wrap">
        <table className="redirects-table">
          <thead>
            <tr>
              <th>Domain</th>
              <th>Redirects To</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {redirectEntries.map((entry) => (
              <tr key={entry.domain}>
                <td>{entry.domain}</td>
                <td>
                  <a href={entry.destination} target="_blank" rel="noreferrer">
                    {entry.destination}
                  </a>
                </td>
                <td>{entry.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RedirectsPage;
